const constant={
    refreshCheckTick:10*60*1000,//10分钟，此处是以毫秒为单位
    checkLoginStatusTime:1*60*1000,//1分钟，此处是以毫秒为单位
    refreshCheckTick_test:4*60*60*1000,//测试刷新时间间隔是4小时
}
export {constant}